export default __webpack_public_path__ + "static/media/profile-placeholder.23f97dd8.png";